import axios from "../../axios"

export default {
  async fetchProducts({ commit }) {
    try {
      const response = await axios.get("/api/products")
      commit('SET_PRODUCTS', response.data.products)
    } catch (error) {
      console.log(error)
    }
  },
  async updateProductPrice({ commit }, { productId, price }) {
    try {
      await axios.put(`/api/products/${productId}`, { price })
      commit('UPDATE_PRODUCT_PRICE', { productId, price })
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async updateSaucePrice({ state, commit }, { sauceName, price }) {
    try {
      const productsWithSauce = state.products.filter(p =>
        p.sauces && p.sauces.some(s => s.name === sauceName)
      )
      await Promise.all(productsWithSauce.map(product => {
        const updatedSauces = product.sauces.map(s =>
          s.name === sauceName ? { ...s, price } : s
        )
        return axios.put(`/api/products/${product._id}`, { sauces: updatedSauces })
      }))
      commit('UPDATE_SAUCE_PRICE', { sauceName, price })
    } catch (error) {
      console.log(error)
      throw error
    }
  },
}
